import type { AnyAction } from "redux";

import {
    SET_PRIMARY_SIDEBAR_DATA,
    TOGGLE_KEEP_SIDEBAR_OPENED,
    TOGGLE_PRIMARY_SIDEBAR,
    TOGGLE_USER_SETTINGS,
} from "app/action_types/primary_sidebar3_action_type";
import { ACTIVATION_HOME_ROUTE } from "app/pages/activation/routing/constants";
import { DEMAND_ANALYSIS_HOME_STATE_NAME, TOPICS_HEATMAP_STATE_NAME } from "app/pages/market-research/shared/constants";
import {
    ACCOUNT_OVERVIEW_COMPANY,
    ACCOUNT_OVERVIEW_CONTACTS,
    ACCOUNT_OVERVIEW_HOME,
    ACCOUNT_REVIEW_ROOT,
    ACCOUNT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
    AI_AGENT_EMAIL,
    AI_AGENT_MEETING,
    AI_AGENT_MEETING_ROOT,
    AI_SUPER_AGENT,
    COMPANY_ANALYSIS_COMPETITORS,
    COMPANY_ANALYSIS_CONTACTS,
    COMPANY_ANALYSIS_DIGITAL_ASSETS,
    COMPANY_ANALYSIS_HOME,
    COMPANY_ANALYSIS_OVERVIEW,
    COMPANY_ANALYSIS_SIGNALS,
    COMPANY_ANALYSIS_TECHNOLOGIES,
    CONTACTS_WATERFALL_PAGE_ROUTE,
    CRM_LIST_MAIN_PAGE_ROUTE,
    CRM_LIST_PAGE_ROUTE,
    DOWNLOAD_EXTENSION_PAGE_ROUTE,
    EMPLOYEE_PROFILES_PAGE_ROUTE,
    ENRICHMENT_PAGE_ROUTE,
    FIND_APPS_SEARCH_PAGE_ROUTE,
    FIND_LEADS_SAVED_SEARCH_ABSTRACT_ROUTE,
    FIND_LEADS_SAVED_SEARCH_ROUTE,
    FIND_LEADS_SEARCH_ROUTE,
    HOME_PAGE_ROUTE,
    MANAGEMENT_ROUTE,
    MY_LISTS_PAGE_ROUTE,
    PREMIUM_FEATURES_PAGE_ROUTE,
    SCORE_SETTINGS_PAGE_ROUTE,
    STATIC_LIST_PAGE_ROUTE,
    WEBSITE_ANALYSIS_ROOT,
} from "app/pages/sales-intelligence/constants/routes";
import {
    EXTENSION_MANAGEMENT_MANAGE_ROUTE,
    HS_MANAGEMENT_MANAGE_ROUTE,
    HS_MANAGEMENT_ROOT_ENRICHMENT_ROUTE,
    HS_MANAGEMENT_ROOT_ROUTE_EXPORT,
    MANAGEMENT_APIS_AND_WEBHOOKS_ROUTE,
    MANAGEMENT_CRM_INTEGRATIONS_ROUTE,
    MANAGEMENT_CRM_ROUTE,
    MANAGEMENT_MCP,
    MANAGEMENT_SIGNALS_API_ROUTE,
    MANAGEMENT_SIGNALS_REST_API_ROUTE,
    SF_MANAGEMENT_MANAGE_ROUTE,
    SF_MANAGEMENT_ROOT_ROUTE_EXPORT,
    SUPPRESSION_LIST_ABSTRACT_ROUTE,
    TEAM_DETAIL_ROUTE,
    TEAMS_MANAGEMENT_ROUTE,
    PLAYBOOK_CREATE_ROUTE,
    PLAYBOOK_EDIT_ROUTE,
    PLAYBOOKS_ROUTE,
} from "app/pages/sales-intelligence/constants/sl_routes";
import { KEYWORD_MARKET_ANALYSIS_GROUP_SEARCH_TRENDS_STATE } from "pro-features/pages/module start page/src/keyword analysis/consts";

export enum EPrimarySideBar3StateType {
    Home = "digitalsuite-home",
    WebMarketAnalysis_home = "digitalsuite_webmarketanalysis_home",
    WebMarketAnalysis_mapping = "digitalsuite_marketresearch_webmarketanalysis_mapping",
    WebMarketResearch_home = "market_research_home",
    MarketResearch_keywordMarketResearch_home = DEMAND_ANALYSIS_HOME_STATE_NAME,
    MarketResearch_keywordMarketResearch_search_trends = KEYWORD_MARKET_ANALYSIS_GROUP_SEARCH_TRENDS_STATE,
    MarketResearch_keywordMarketResearch_topics_heatmap = TOPICS_HEATMAP_STATE_NAME,
    MarketResearch_keywordMarketAnalysis_home = "digitalsuite_marketresearch_keywordmarketanalysis_home",
    MarketResearch_appMarketAnalysis_home = "digitalsuite_marketresearch_appmarketanalysis_home",
    WebsiteAnalysis_home = "digitalsuite_websiteanalysis_home",
    Segments_homepage = "digitalsuite_segments-homepage",
    AppAnalysis_home = "digitalsuite_appanalysis_home",
    Acquisition_home = "digitalsuite_acquisition-home",
    SearchIntelligence = "ranktracker",
    LLMTracking_home = "digitalsuite_llm_solutions_homepage",
    LLMTracking = "digitalsuite_llm_solutions_report",
    LLMTraffic = "aitraffic.frame.overview",
    AIResearch_home = "airesearch.home",
    AIResearch_brandResearchReport = "airesearch.brandResearch.report",
    AIResearch_industryResearchReport = "airesearch.industryResearch.report",
    Recommendations_overview = "recommendations.frame.report.overview",
    MonitorAndProtect = "digitalsuite_monitor_and_protect_home",
    KeywordResearch = "digitalsuite_monitorkeywords_home",
    BacklinksAnalysis = "digitalsuite_findaffiliates_home",
    SiteAudit = "digitalsuite_site_audit_home",
    Organic_Search = "organicsearch_websiteanalysis_home",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    Search = "organicsearch_websiteanalysis_home",
    Paid_Search = "paidsearch_websiteanalysis_home",
    Dashboards = "dashboard",
    Conversion_homepage = "conversion-homepage",
    PremiumFeatures = "premium-features-homepage",
    CustomInsights = "CustomInsights",
    RankTracker_home = "ranktracker.home",
    Backlinks_home = "digitalsuite_backlinks_overview",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    SiteAudit_home = "digitalsuite_site_audit_home",
    BrandMonitoring_home = "brandmonitoring.home",
    Activation = ACTIVATION_HOME_ROUTE,
    // Sales Intelligence
    SIHome = HOME_PAGE_ROUTE,
    SICompanyOverviewHome = ACCOUNT_OVERVIEW_HOME,
    SICompanyAnalysisHome = COMPANY_ANALYSIS_HOME,
    SICompanyOverview = ACCOUNT_OVERVIEW_COMPANY,
    SICompanyAnalysisOverview = COMPANY_ANALYSIS_OVERVIEW,
    SICompanyAnalysisSignals = COMPANY_ANALYSIS_SIGNALS,
    SICompanyAnalysisDigitalAssets = COMPANY_ANALYSIS_DIGITAL_ASSETS,
    SICompanyAnalysisTechnologies = COMPANY_ANALYSIS_TECHNOLOGIES,
    SICompanyAnalysisCompetitors = COMPANY_ANALYSIS_COMPETITORS,
    SICompanyContacts = ACCOUNT_OVERVIEW_CONTACTS,
    SICompanyAnalysisContacts = COMPANY_ANALYSIS_CONTACTS,
    SIAccountReview = ACCOUNT_REVIEW_ROOT,
    SIWebsiteAnalysis = WEBSITE_ANALYSIS_ROOT,
    SIAIAgentMeetingHome = AI_AGENT_MEETING_ROOT,
    SIAIAgentMeetingChat = AI_AGENT_MEETING,
    SIAIAgentEmail = AI_AGENT_EMAIL,
    SIAISuperAgent = AI_SUPER_AGENT,
    SIMyList = MY_LISTS_PAGE_ROUTE,
    SIStaticList = STATIC_LIST_PAGE_ROUTE,
    SICRMList = CRM_LIST_PAGE_ROUTE,
    SISearch = FIND_LEADS_SEARCH_ROUTE,
    SIFindLeadsSavedSearch = FIND_LEADS_SAVED_SEARCH_ROUTE,
    SIFindLeads = FIND_LEADS_SAVED_SEARCH_ABSTRACT_ROUTE,

    SIFindApps = FIND_APPS_SEARCH_PAGE_ROUTE,

    SIAccountSignalsManagement = ACCOUNT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
    SIManageIntegrations = MANAGEMENT_ROUTE,
    SIManageCRM = MANAGEMENT_CRM_ROUTE,
    SIManageCRMIntegrations = MANAGEMENT_CRM_INTEGRATIONS_ROUTE,
    SIManageAPIsAndWebhooks = MANAGEMENT_APIS_AND_WEBHOOKS_ROUTE,
    SIManageMCPs = MANAGEMENT_MCP,
    SIManageIntegrationsSF = SF_MANAGEMENT_MANAGE_ROUTE,
    SIManageIntegrationsSFExport = SF_MANAGEMENT_ROOT_ROUTE_EXPORT,
    SIManageIntegrationsHS = HS_MANAGEMENT_MANAGE_ROUTE,
    SIManageIntegrationsSignalApi = MANAGEMENT_SIGNALS_API_ROUTE,
    SIManageIntegrationsSignalsRestApi = MANAGEMENT_SIGNALS_REST_API_ROUTE,
    SIManageIntegrationsExtension = EXTENSION_MANAGEMENT_MANAGE_ROUTE,
    SIManageIntegrationsHSExport = HS_MANAGEMENT_ROOT_ROUTE_EXPORT,
    SIManageIntegrationsHSEnrichment = HS_MANAGEMENT_ROOT_ENRICHMENT_ROUTE,
    SIManageIntegrationsSL = SUPPRESSION_LIST_ABSTRACT_ROUTE,
    SIEnrichment = ENRICHMENT_PAGE_ROUTE,
    SIScoreSettings = SCORE_SETTINGS_PAGE_ROUTE,
    SICRMLists = CRM_LIST_MAIN_PAGE_ROUTE,
    SIMyCrnList = CRM_LIST_PAGE_ROUTE,
    SIDownloadExtension = DOWNLOAD_EXTENSION_PAGE_ROUTE,
    SIPremiumFeatures = PREMIUM_FEATURES_PAGE_ROUTE,
    SIContactsWaterfall = CONTACTS_WATERFALL_PAGE_ROUTE,
    SIEmployeeProfiles = EMPLOYEE_PROFILES_PAGE_ROUTE,
    SITeamsManagement = TEAMS_MANAGEMENT_ROUTE,
    SITeamDetail = TEAM_DETAIL_ROUTE,
    SIPlaybooks = PLAYBOOKS_ROUTE,
    SIPlaybookCreate = PLAYBOOK_CREATE_ROUTE,
    SIPlaybookEdit = PLAYBOOK_EDIT_ROUTE,
    // ------
    AdvertiserActivity = "displayadvertising.homepage",
    PublisherAnalysis = "publisheranalysis.homepage",
    AdTracker = "adtracker.home",
    SISalesAdvertiserActivity = "salesIntelligence-advertiseractivity.homepage",
    SISalesPublisherAnalysis = "salesIntelligence-publisheranalysis.homepage",
    SISalesMonitorAndProtect = "salesIntelligence-monitorandprotect.home",
    None = "None",
}

export enum EPrimarySideBar3IdType {
    Homepage = "Homepage",
    WebMarketAnalysis = "WebMarketAnalysis",
    WebMarketResearch = "WebMarketResearch",
    SearchInterestsAnalysis = "SearchInterestsAnalysis",
    DemandAnalysis = "DemandAnalysis",
    AppMarketAnalysis = "AppMarketAnalysis",
    WebsiteAnalysis = "WebsiteAnalysis",
    WebsiteSegmentsAnalysis = "WebsiteSegmentsAnalysis",
    AppAnalysis = "AppAnalysis",
    SearchIntelligence = "SearchIntelligence",
    KeywordResearch = "KeywordResearch",
    BacklinksAnalysis = "BacklinksAnalysis",
    SiteAudit = "SiteAudit",
    SeoOrganicSearch = "SeoOrganicSearch",
    SeoSearch = "SeoSearch",
    PaidSearch = "PaidSearch",
    Dashboards = "Dashboards",
    PremiumFeatures = "PremiumFeatures",
    CustomInsights = "CustomInsights",
    ConversionAnalysis = "ConversionAnalysis",
    BrandMonitoring = "BrandMonitoring",
    Solutions = "Solutions",
    UpdatesAndNews = "UpdatesAndNews",
    Settings = "Settings",
    Demo = "Demo",
    Activation = "Activation",
    AdvertiserActivity = "AdvertiserActivity",
    PublisherAnalysis = "PublisherAnalysis",
    AdTracker = "AdTracker",
    MonitorAndProtect = "MonitorAndProtect",
    // Sales Intelligence — Ad Intelligence (SI copies)
    SISalesAdvertiserActivity = "SISalesAdvertiserActivity",
    SISalesPublisherAnalysis = "SISalesPublisherAnalysis",
    SISalesMonitorAndProtect = "SISalesMonitorAndProtect",
    // Sales Intelligence
    SIHome = "SIHomepage",
    SICompanyOverview = "SICompanyOverview",
    SICompanyAnalysis = "SICompanyAnalysis",
    SIAIAgentMeetingHome = "SIAIAgentMeetingHome",
    SIAIAgentEmail = "SIAIAgentEmail",
    SIMyList = "SIMyLists",
    SISearch = "SIFindLeadsSearch",
    SIFindApps = "SIFindApps",
    SIAccountSignalsManagement = "SIAccountSignalsManagement",
    SIManageIntegrations = "SIManageIntegrations",
    SIManageCRM = "SIManageCRM",
    SIManageAPIsAndWebhooks = "SIManageAPIsAndWebhooks",
    SIManageMCPs = "SIManageMCPs",
    SIEnrichment = "SIEnrichment",
    SIScoreSettings = "SIScoreSettings",
    SIDownloadExtension = "SIDownloadExtension",
    SIPremiumFeatures = "SIPremiumFeatures",
    SICRMLists = "SICRMLists",
    SIContactsWaterfall = "SIContactsWaterfall",
    SIEmployeeProfiles = "SIEmployeeProfiles",
    SITeams = "SITeams",
    SIPlaybooks = "SIPlaybooks",
    // ------
    LLMTracker = "LLMTracker",
    LLMTraffic = "LLMTraffic",
    AIResearch = "AIResearch",
    Recommendations = "Recommendations",
}

type IMappingStateToId = {
    [key in EPrimarySideBar3IdType]: EPrimarySideBar3StateType | EPrimarySideBar3StateType[] | null;
};

export const mappingStateToId: IMappingStateToId = {
    [EPrimarySideBar3IdType.Homepage]: EPrimarySideBar3StateType.Home,
    [EPrimarySideBar3IdType.WebMarketAnalysis]: [
        EPrimarySideBar3StateType.WebMarketAnalysis_home,
        EPrimarySideBar3StateType.WebMarketAnalysis_mapping,
    ],
    [EPrimarySideBar3IdType.WebMarketResearch]: EPrimarySideBar3StateType.WebMarketResearch_home,
    [EPrimarySideBar3IdType.SearchInterestsAnalysis]:
        EPrimarySideBar3StateType.MarketResearch_keywordMarketAnalysis_home,
    [EPrimarySideBar3IdType.DemandAnalysis]: [
        EPrimarySideBar3StateType.MarketResearch_keywordMarketResearch_home,
        EPrimarySideBar3StateType.MarketResearch_keywordMarketResearch_search_trends,
        EPrimarySideBar3StateType.MarketResearch_keywordMarketResearch_topics_heatmap,
    ],
    [EPrimarySideBar3IdType.AppMarketAnalysis]: EPrimarySideBar3StateType.MarketResearch_appMarketAnalysis_home,
    [EPrimarySideBar3IdType.WebsiteAnalysis]: EPrimarySideBar3StateType.WebsiteAnalysis_home,
    [EPrimarySideBar3IdType.WebsiteSegmentsAnalysis]: EPrimarySideBar3StateType.Segments_homepage,
    [EPrimarySideBar3IdType.AppAnalysis]: EPrimarySideBar3StateType.AppAnalysis_home,
    [EPrimarySideBar3IdType.SearchIntelligence]: EPrimarySideBar3StateType.SearchIntelligence,
    [EPrimarySideBar3IdType.KeywordResearch]: EPrimarySideBar3StateType.KeywordResearch,
    [EPrimarySideBar3IdType.BacklinksAnalysis]: EPrimarySideBar3StateType.BacklinksAnalysis,
    [EPrimarySideBar3IdType.SiteAudit]: EPrimarySideBar3StateType.SiteAudit,
    [EPrimarySideBar3IdType.SeoOrganicSearch]: EPrimarySideBar3StateType.Organic_Search,
    [EPrimarySideBar3IdType.SeoSearch]: EPrimarySideBar3StateType.Search,
    [EPrimarySideBar3IdType.PaidSearch]: EPrimarySideBar3StateType.Paid_Search,
    [EPrimarySideBar3IdType.Dashboards]: EPrimarySideBar3StateType.Dashboards,
    [EPrimarySideBar3IdType.PremiumFeatures]: EPrimarySideBar3StateType.PremiumFeatures,
    [EPrimarySideBar3IdType.CustomInsights]: EPrimarySideBar3StateType.CustomInsights,
    [EPrimarySideBar3IdType.ConversionAnalysis]: EPrimarySideBar3StateType.Conversion_homepage,
    [EPrimarySideBar3IdType.BrandMonitoring]: EPrimarySideBar3StateType.BrandMonitoring_home,
    [EPrimarySideBar3IdType.Solutions]: null,
    [EPrimarySideBar3IdType.UpdatesAndNews]: null,
    [EPrimarySideBar3IdType.Settings]: null,
    [EPrimarySideBar3IdType.Demo]: null,
    [EPrimarySideBar3IdType.Activation]: EPrimarySideBar3StateType.Activation,
    [EPrimarySideBar3IdType.AdvertiserActivity]: EPrimarySideBar3StateType.AdvertiserActivity,
    [EPrimarySideBar3IdType.AdTracker]: EPrimarySideBar3StateType.AdTracker,
    [EPrimarySideBar3IdType.SISalesAdvertiserActivity]: EPrimarySideBar3StateType.SISalesAdvertiserActivity,
    [EPrimarySideBar3IdType.SISalesPublisherAnalysis]: EPrimarySideBar3StateType.SISalesPublisherAnalysis,
    [EPrimarySideBar3IdType.SISalesMonitorAndProtect]: EPrimarySideBar3StateType.SISalesMonitorAndProtect,
    [EPrimarySideBar3IdType.SIHome]: [EPrimarySideBar3StateType.SIHome, EPrimarySideBar3StateType.SIAISuperAgent],
    [EPrimarySideBar3IdType.SICompanyOverview]: [
        EPrimarySideBar3StateType.SICompanyOverviewHome,
        EPrimarySideBar3StateType.SICompanyOverview,
        EPrimarySideBar3StateType.SICompanyContacts,
        EPrimarySideBar3StateType.SIAccountReview,
    ],
    [EPrimarySideBar3IdType.SICompanyAnalysis]: [
        EPrimarySideBar3StateType.SICompanyAnalysisHome,
        EPrimarySideBar3StateType.SICompanyAnalysisOverview,
        EPrimarySideBar3StateType.SICompanyAnalysisContacts,
        EPrimarySideBar3StateType.SICompanyAnalysisSignals,
        EPrimarySideBar3StateType.SICompanyAnalysisDigitalAssets,
        EPrimarySideBar3StateType.SICompanyAnalysisTechnologies,
        EPrimarySideBar3StateType.SICompanyAnalysisCompetitors,
        EPrimarySideBar3StateType.SIWebsiteAnalysis,
    ],
    [EPrimarySideBar3IdType.SIAIAgentMeetingHome]: [
        EPrimarySideBar3StateType.SIAIAgentMeetingHome,
        EPrimarySideBar3StateType.SIAIAgentMeetingChat,
    ],
    [EPrimarySideBar3IdType.SIAIAgentEmail]: EPrimarySideBar3StateType.SIAIAgentEmail,
    [EPrimarySideBar3IdType.SIMyList]: [EPrimarySideBar3StateType.SIMyList, EPrimarySideBar3StateType.SIStaticList],
    [EPrimarySideBar3IdType.SISearch]: [
        EPrimarySideBar3StateType.SIFindLeadsSavedSearch,
        EPrimarySideBar3StateType.SIFindLeads,
    ],
    [EPrimarySideBar3IdType.SIFindApps]: EPrimarySideBar3StateType.SIFindApps,
    [EPrimarySideBar3IdType.SIAccountSignalsManagement]: EPrimarySideBar3StateType.SIAccountSignalsManagement,
    [EPrimarySideBar3IdType.SIManageIntegrations]: [
        EPrimarySideBar3StateType.SIManageIntegrations,
        EPrimarySideBar3StateType.SIManageIntegrationsSL,
        EPrimarySideBar3StateType.SIManageIntegrationsSignalApi,
        EPrimarySideBar3StateType.SIManageIntegrationsSignalsRestApi,
        EPrimarySideBar3StateType.SIManageIntegrationsExtension,
    ],
    [EPrimarySideBar3IdType.SIManageCRM]: [
        EPrimarySideBar3StateType.SIManageCRM,
        EPrimarySideBar3StateType.SIManageCRMIntegrations,
        EPrimarySideBar3StateType.SIManageIntegrationsSF,
        EPrimarySideBar3StateType.SIManageIntegrationsSFExport,
        EPrimarySideBar3StateType.SIManageIntegrationsHS,
        EPrimarySideBar3StateType.SIManageIntegrationsHSExport,
        EPrimarySideBar3StateType.SIManageIntegrationsHSEnrichment,
    ],
    [EPrimarySideBar3IdType.SIManageAPIsAndWebhooks]: EPrimarySideBar3StateType.SIManageAPIsAndWebhooks,
    [EPrimarySideBar3IdType.SIManageMCPs]: EPrimarySideBar3StateType.SIManageMCPs,
    [EPrimarySideBar3IdType.SIEnrichment]: EPrimarySideBar3StateType.SIEnrichment,
    [EPrimarySideBar3IdType.SIScoreSettings]: EPrimarySideBar3StateType.SIScoreSettings,
    [EPrimarySideBar3IdType.SIDownloadExtension]: EPrimarySideBar3StateType.SIDownloadExtension,
    [EPrimarySideBar3IdType.SICRMLists]: [EPrimarySideBar3StateType.SICRMLists, EPrimarySideBar3StateType.SIMyCrnList],
    [EPrimarySideBar3IdType.PublisherAnalysis]: EPrimarySideBar3StateType.PublisherAnalysis,
    [EPrimarySideBar3IdType.LLMTracker]: [
        EPrimarySideBar3StateType.LLMTracking_home,
        EPrimarySideBar3StateType.LLMTracking,
    ],
    [EPrimarySideBar3IdType.LLMTraffic]: EPrimarySideBar3StateType.LLMTraffic,
    [EPrimarySideBar3IdType.AIResearch]: [
        EPrimarySideBar3StateType.AIResearch_home,
        EPrimarySideBar3StateType.AIResearch_brandResearchReport,
        EPrimarySideBar3StateType.AIResearch_industryResearchReport,
    ],
    [EPrimarySideBar3IdType.Recommendations]: EPrimarySideBar3StateType.Recommendations_overview,
    [EPrimarySideBar3IdType.MonitorAndProtect]: EPrimarySideBar3StateType.MonitorAndProtect,
    [EPrimarySideBar3IdType.SIPremiumFeatures]: EPrimarySideBar3StateType.SIPremiumFeatures,
    [EPrimarySideBar3IdType.SIContactsWaterfall]: EPrimarySideBar3StateType.SIContactsWaterfall,
    [EPrimarySideBar3IdType.SIEmployeeProfiles]: EPrimarySideBar3StateType.SIEmployeeProfiles,
    [EPrimarySideBar3IdType.SITeams]: [
        EPrimarySideBar3StateType.SITeamsManagement,
        EPrimarySideBar3StateType.SITeamDetail,
    ],
    [EPrimarySideBar3IdType.SIPlaybooks]: [
        EPrimarySideBar3StateType.SIPlaybooks,
        EPrimarySideBar3StateType.SIPlaybookCreate,
        EPrimarySideBar3StateType.SIPlaybookEdit,
    ],
};

export interface IPrimaryBarData {
    //represents the state we are on
    state: EPrimarySideBar3StateType | null;
    //represents the id of the page we are on.
    //helps in case that multiple subsection that has the same homepage(state), for example: "SEO" & "Paid search"
    id: EPrimarySideBar3IdType | null;
}

interface IPrimarySidebarReducer {
    //Indicates whether the primary navbar is opened or not
    isPrimarySidebarOpened: boolean;

    //Indicates which navbar is currently displayed
    primaryBarData: IPrimaryBarData;

    //true if user settings dialog is opened
    isUserSettingsOpened: boolean;

    isKeepSidebarOpened: boolean;
}

const getDefaultState = (): IPrimarySidebarReducer => {
    return {
        primaryBarData: { state: null, id: null },
        isPrimarySidebarOpened: true,
        isUserSettingsOpened: false,
        isKeepSidebarOpened: false,
    };
};

function primaryBar(state: IPrimarySidebarReducer = getDefaultState(), action: AnyAction) {
    switch (action.type) {
        case TOGGLE_PRIMARY_SIDEBAR:
            return {
                ...state,
                isPrimarySidebarOpened: action.isPrimarySidebarOpened,
            };

        case SET_PRIMARY_SIDEBAR_DATA:
            return {
                ...state,
                primaryBarData: action.primaryBarData,
            };

        case TOGGLE_USER_SETTINGS:
            return {
                ...state,
                isUserSettingsOpened: action.isUserSettingsOpened,
            };

        case TOGGLE_KEEP_SIDEBAR_OPENED:
            return {
                ...state,
                isKeepSidebarOpened: action.isKeepSidebarOpened,
            };

        default:
            return state;
    }
}

export default primaryBar;
